// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { assignShipToAddressModalStyles } from "@steiner/Overrides/Widgets/UserSetup/AssignShipToAddressModal";
import { color, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

assignShipToAddressModalStyles.modal = { sizeVariant: "medium" };

assignShipToAddressModalStyles.buttonsWrapper = {
    css: css`
        margin-top: 30px;
        display: flex;
        gap: 10px;
        justify-content: end;
        ${xScreen("lt", "xs")} {
            flex-direction: column-reverse;
        }
    `,
};

assignShipToAddressModalStyles.cancelButton = {
    variant: "secondary",
    css: css`
        ${xScreen("lt", "xs")} {
            width: 100%;
        }
    `,
};

assignShipToAddressModalStyles.saveButton = {
    css: css`
        ${xScreen("lt", "xs")} {
            width: 100%;
        }
    `,
};

assignShipToAddressModalStyles.selectAllWrapper = {
    css: css`
        display: flex;
        justify-content: flex-end;
        padding: 10px 20px;
        background: ${color("common.ui8", .1)};
        & > div {
            width: calc(22% - 3px);
        }
        ${xScreen("lte","sm")} {
            justify-content: flex-start;
            padding: 10px;
            & > div {
                width: 100%;
            }
        }
    `,
};

assignShipToAddressModalStyles.shipToNumberGridItem = {
    width: [12, 12, 2, 2, 2],
    css: css`
        flex-direction: column;
    `,
};

assignShipToAddressModalStyles.costCodeGridItem = {
    width: [12, 12, 3, 3, 3],
};

assignShipToAddressModalStyles.addressInfoGridItem = { width: [12, 12, 4, 4, 4] };
assignShipToAddressModalStyles.assignShippingAddressGridItem = { width: [12, 12, 3, 3, 3] };